import { createContext, useContext } from "react";

import { InspectorSessionExpired } from "./inspector/inspectorApi";
import { ObservabilitySessionExpired } from "./observability/observabilityApi";
import { OperatorSessionExpired } from "./operatorHttp";

/** Lets a panel tell the console that an operator API answered 401. */
export const SessionExpiredContext = createContext<() => void>(() => undefined);

export function useReportSessionExpired(): () => void {
  return useContext(SessionExpiredContext);
}

export function isSessionExpired(error: unknown): boolean {
  return (
    error instanceof OperatorSessionExpired ||
    error instanceof ObservabilitySessionExpired ||
    error instanceof InspectorSessionExpired
  );
}
